import { add, initAll, setUserId, setGroup, groupIdentify, Identify } from '@amplitude/unified';

/**
 * Initialize Amplitude analytics
 * This function is called by the consent manager when analytics consent is granted
 */
export async function initializeAmplitude() {
  const amplitudeApiKey = document.querySelector("meta[name=amplitude_api_key]")?.content;

  if (!amplitudeApiKey) {
    return;
  }

  const demoSandbox = document.querySelector("meta[name=demo_sandbox]")?.content === "true";
  if (demoSandbox) {
    const demoSandboxEventRename = {
      name: "demo-sandbox-event-rename",
      type: "enrichment",
      execute(event) {
        let eventName = event.event_type

        // Don't change events that begin with $
        if (eventName.startsWith("$")) return event

        if (eventName.startsWith("[Amplitude] ")) {
          eventName = eventName.replace("[Amplitude] ", "")
        }
        eventName = `DemoEnv ${eventName}`
        event.event_type = eventName

        return event
      }
    }
    add(demoSandboxEventRename)
  }

  await initAll(amplitudeApiKey, {
    fetchRemoteConfig: true,
    analytics: {
      autocapture: true,
      // Overriding `minIdLength` to support Portal's integer User primary keys.
      // (The default of `5` would cause user ids < 10000 to be rejected by
      // the Amplitude API.)
      minIdLength: 1,
      // the serverUrl must be the explicit address, path and all
      serverUrl: 'https://amplitude.huntress.io/2/httpapi',
      cdnUrl: 'https://amplitude.huntress.io',
    },
    sessionReplay: {
      sampleRate: 1,
    },
    engagement: {
      serverUrl: 'https://amplitude.huntress.io',
      cdnUrl: 'https://amplitude.huntress.io',
    },
  });

  const userId = document.querySelector("meta[name=user_id]")?.content;
  const groupType = 'account_id';
  const groupName = document.querySelector("meta[name=account_id]")?.content;

  setUserId(userId || "unauthenticated");
  setGroup(groupType, groupName);

  if (groupName) {
    const accountCreatedAt = document.querySelector("meta[name=account_created_at]")?.content;
    const groupIdentifyEvent = new Identify();

    const isShowcase = document.querySelector("meta[name=is_showcase]")?.content === "true";
    groupIdentifyEvent.set('created_at', accountCreatedAt);
    groupIdentifyEvent.set('is_showcase', isShowcase);
    groupIdentify(groupType, groupName, groupIdentifyEvent);
  }
}
